export default __webpack_public_path__ + "static/media/No42.38453289.jpeg";